export const formatAwardPoints = (points: number): string =>
  points > 0 ? `+${points}` : String(points);
